import React from 'react';
import { Card, Typography, Tag, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './System.module.scss';

const { Text, Paragraph } = Typography;

const BootParams = ({ bootParams }) => {
  // 부트 파라미터 파싱
  const parseBootParams = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const params = [];
      const line = data.trim();
      const parts = line.split(/\s+/);
      
      parts.forEach(part => {
        if (part.includes('=')) {
          const [key, value] = part.split('=');
          params.push({ key, value, full: part });
        } else {
          params.push({ key: part, value: '', full: part });
        }
      });
      
      return params;
    } catch (error) {
      console.error('Error parsing boot params:', error);
      return [];
    }
  };

  const params = parseBootParams(bootParams);

  return (
    <Card 
      title={
        <div>
          부트 파라미터
          <Tooltip title="커널 부팅 시 사용되는 파라미터입니다.">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      className={styles.systemCard}
    >
      <Paragraph className={styles.bootParamsContainer}>
        {params.map((param, index) => (
          <Tag key={index} className={styles.bootParam}>
            {param.key}
            {param.value && <Text type="secondary">=</Text>}
            {param.value && <Text>{param.value}</Text>}
          </Tag>
        ))}
      </Paragraph>
      
      <div className={styles.rawParams}>
        <Text type="secondary">원본 부트 파라미터:</Text>
        <Paragraph copyable className={styles.rawParamsText}>
          {bootParams}
        </Paragraph>
      </div>
    </Card>
  );
};

export default BootParams;